import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

import { Icon, type IconProps } from '@fv/client-components'

import { AdminTooltip } from './AdminTooltip'

export const AdminHelp = ({
  children,
  ...iconProps
}: PropsWithChildren<Partial<Omit<IconProps, 'ref'>>>) => {
  return (
    <AdminTooltip label={children}>
      <Icon
        {...iconProps}
        className={clsx('ml-2 text-xs', iconProps.className)}
        icon="question-circle"
      />
    </AdminTooltip>
  )
}
